import { IConsoleCapture } from '../domain/interfaces/IConsoleCapture';
import { INetworkCapture } from '../domain/interfaces/INetworkCapture';
import { IInteractionCapture } from '../domain/interfaces/IInteractionCapture';
import { INavigationCapture } from '../domain/interfaces/INavigationCapture';
import { IPerformanceCapture } from '../domain/interfaces/IPerformanceCapture';
import { IVisibilityCapture } from '../domain/interfaces/IVisibilityCapture';
import { ITransport } from '../domain/interfaces/ITransport';
import { ILogger } from '../domain/interfaces/ILogger';
import { ICaptureFactory, ITransportFactory, ILoggerFactory } from '../domain/interfaces/ICaptureFactory';
import { SdkConfig } from '../domain/types';

export interface ISdkContainer {
  getConsoleCapture(): IConsoleCapture;
  getNetworkCapture(): INetworkCapture;
  getInteractionCapture(): IInteractionCapture;
  getNavigationCapture(): INavigationCapture;
  getPerformanceCapture(): IPerformanceCapture;
  getVisibilityCapture(): IVisibilityCapture;
  getTransport(): ITransport;
  getLogger(): ILogger;
}

export interface SdkContainerFactories {
  captureFactory: ICaptureFactory;
  transportFactory: ITransportFactory;
  loggerFactory: ILoggerFactory;
}

export class SdkContainer implements ISdkContainer {
  private consoleCapture: IConsoleCapture;
  private networkCapture: INetworkCapture;
  private interactionCapture: IInteractionCapture;
  private navigationCapture: INavigationCapture;
  private performanceCapture: IPerformanceCapture;
  private visibilityCapture: IVisibilityCapture;
  private transport: ITransport;
  private logger: ILogger;

  constructor(config: SdkConfig, factories: SdkContainerFactories) {
    const { captureFactory, transportFactory, loggerFactory } = factories;

    this.transport = transportFactory.createTransport(config);
    this.consoleCapture = captureFactory.createConsoleCapture();
    this.networkCapture = captureFactory.createNetworkCapture();
    this.interactionCapture = captureFactory.createInteractionCapture();
    this.navigationCapture = captureFactory.createNavigationCapture();
    this.performanceCapture = captureFactory.createPerformanceCapture();
    this.visibilityCapture = captureFactory.createVisibilityCapture();
    this.logger = loggerFactory.createLogger();
  }

  getConsoleCapture(): IConsoleCapture {
    return this.consoleCapture;
  }

  getNetworkCapture(): INetworkCapture {
    return this.networkCapture;
  }

  getInteractionCapture(): IInteractionCapture {
    return this.interactionCapture;
  }

  getNavigationCapture(): INavigationCapture {
    return this.navigationCapture;
  }

  getPerformanceCapture(): IPerformanceCapture {
    return this.performanceCapture;
  }

  getVisibilityCapture(): IVisibilityCapture {
    return this.visibilityCapture;
  }

  getTransport(): ITransport {
    return this.transport;
  }

  getLogger(): ILogger {
    return this.logger;
  }
}